<template>
    <div class="echart-box">
        <v-chart :options="option" ref="my" autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'
import echarts from 'echarts'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar';
import 'zrender/lib/svg/svg'
export default {
    name:"char1",
    components:{
         'v-chart': ECharts
    },
    props:{
        bw:{
            type:String,
            default:"15"
        },
        data:Object,
        datelist:{
            type:Array,
            default:()=>{
              return []
            }
        }
    },
    data(){
        return {
            option:{},
            viewdata:{},
      viewbatch:[]
        }
    },
    watch:{
         datelist:{
            handler(){  
                          
              this.dataInit();
              this.init()
            },
            deep:false
        }
    },
    methods:{
         dataInit(){                   
            this.viewdata.rates= this.data.rates.slice(0,10); 
            this.viewbatch=this.datelist.slice(0,10);    
           this.doit()
        },
        init(){                                 
              this.option={
                grid: {
                    top:'18%',
                    left: '4%',
                    right: '4%',
                    bottom:'2%',
                    containLabel: true
                },               
                tooltip:{
                    formatter: function(params,index) {                            
                    　　var result = `批次：${params.name}</br>准校率：${params.value}</br>`                             
                    　　return result                
                    },
                    textStyle:{
                        fontSize:this.chartFontSize
                    }
                },                
                xAxis: {         
                    boundaryGap: false,        				  
                     splitLine: {
                        show: false                       
                    },                  
                    axisLabel: {             
                      color: "#fff",
                      rotate:40,
                       margin:20
                    },
                     axisTick:{
                        show:false
                    },
                    barGap: '0$',
                    type: 'category',                              
                    data: this.viewbatch,
                },
                yAxis: {
                    axisLabel: {             
                      color:'#fff',
                      formatter:'{value}%'     
                    },
                    axisLine:{
                        show:false,
                    },
                     splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#323645',
                            width:1,
                        },
                        minInterval:0
                    },
                    type: 'value',
                },
                series: [{     
                    data: this.viewdata.rates,
                    type: 'bar',
                    label:{
                        show: true,
                        position: 'top',
                        color:function(params){
                            if(params.dataIndex==5){
                                return '#f65685'
                            }
                        },
                        fontSize:this.chartFontSize-6
                    },
                    itemStyle:{
                           barBorderRadius: [9, 9, 0, 0],
                            color: function(params){
                                if(params.dataIndex==5){
                                    return "#EACD2C"
                                }else {
                                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                        offset: 0,
                                        color: '#3374f0'
                                    }, {
                                        offset: 1,
                                        color: '#142d77'
                                    }])
                                }
                            }
                         
                    },
                     emphasis: {
                        label: {
                        show: true,
                        position: 'top',
                        color:'#f65685'
                    },
                        itemStyle: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#f65685'
                            }, {
                                offset: 1,
                                color: '#271e57'
                            }])      
                        }
                    },
                    seriesIndex:0,
                    barWidth:this.barWidth     
                }]
            }
             setTimeout(()=>{
                  
                this.$nextTick(()=>{
                    this.$refs.my.dispatchAction({
                        type: 'showTip',         
                        seriesIndex:0,
                        dataIndex: 5                     
                    })
                })
            },500)              
                  
        },
        rundata(){
            this.data.rates.push(this.data.rates.shift())
           this.datelist.push(this.datelist.shift());   
        },
        //动画
        doit(){    
            let that=this
            setTimeout(()=>{
                 that.rundata()
            },3000)
        },
    },
    mounted(){
        //   this.init()
    }
}
</script>